import apiService from 'src/enviroment';

const searchVideos = async (search, nextPage) => {
  const response = await apiService.get(
    `/youtube/buscador/?q=${search}&${
      typeof nextPage === 'string' ? `${nextPage}` : null
    }`,
  );
  try {
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log('Error searchVideos');
  }
};

const getVideosId = async (id) => {
  const response = await apiService.get(`/youtube/videos/?_id=${id}`);
  try {
    if (response.status === 200 && response.data.success === 1) {
      return response.data.data;
    }
  } catch (error) {
    console.log('Error searchVideos');
  }
};

const createVideoToList = async (id, value) => {
  const body = {
    _id: id,
    video: {
      kind: value.kind,
      etag: value.etag,
      id: {
        kind: value.items[0].kind,
        videoId: value.videoId,
      },
      snippet: value.items[0].snippet,
    },
  };
  const response = await apiService.post('/youtube/videos/', body);
  try {
    if (response.status === 200 && response.data.success === 1) {
      return response.data;
    }
  } catch (error) {
    console.log('Error createVideoToList');
  }
};

const evaluateFeeling = async (feling) => {
  const {
    listaId, analisisId, text, sentiment, videoId,
  } = feling;
  const body = {
    listaId,
    analisisId,
    beginOffset: text.beginOffset,
    confirmacion: sentiment.confirmacion,
    videoId,
  };
  const response = await apiService.post(
    '/youtube/sentimientos/confirmacion/',
    body,
  );
  try {
    if (response.status === 200 && response.data.success === 1) {
      return response.data;
    }
  } catch (error) {
    console.log('Error evaluateSentiminet');
  }
};

const getListTags = async () => {
  const response = await apiService.get('/youtube/listas/');
  try {
    if (response.status === 200) {
      return response.data.data;
    }
  } catch (error) {
    console.log('Error get List ');
  }
};

const getComments = async (idList, idAnalized) => {
  const response = await apiService.get(
    `/youtube/comentarios/?listaId=${idList}&analisisId=${idAnalized}`,
  );
  try {
    if (response.status === 200) {
      return response.data.data;
    }
  } catch (error) {
    console.log('Error get comments ById ');
  }
};

const getCommentsbyVideoId = async (idList, idAnalized, videoId) => {
  const response = await apiService.get(
    `/youtube/comentarios/?listaId=${idList}&analisisId=${idAnalized}&videoId=${videoId}`,
  );
  try {
    if (response.status === 200) {
      return response.data.data;
    }
  } catch (error) {
    console.log('Error get comments ById ');
  }
};

const getFeelings = async (idList, idAnalized) => {
  const response = await apiService.get(
    `/youtube/sentimientos/?listaId=${idList}&analisisId=${idAnalized}`,
  );
  try {
    if (response.status === 200) {
      return response.data.data;
    }
  } catch (error) {
    console.log('Error get List ', error);
  }
};

const getFeelingsById = async (idList, idAnalized, videoId) => {
  const response = await apiService.get(
    `/youtube/sentimientos/?listaId=${idList}&analisisId=${idAnalized}&videoId=${videoId}`,
  );
  try {
    if (response.status === 200) {
      return response.data.data;
    }
  } catch (error) {
    console.log('Error get List ');
  }
};

const createList = async (params) => {
  const response = await apiService.post('/youtube/listas/', params);
  try {
    if (response.status === 200 && response.data.success === 1) {
      return response.data;
    }
  } catch (error) {
    console.log('Error create List');
  }
};

const updateList = async (params) => {
  const response = await apiService.put('/youtube/listas/', params);
  try {
    if (response.status === 200 && response.data.success === 1) {
      return response.data;
    }
  } catch (error) {
    console.log('Error create List');
  }
};

const deleteList = async (id) => {
  const response = await apiService.delete(`/youtube/listas/?_id=${id} `);
  try {
    if (response.status === 200 && response.data.success === 1) {
      return response.data;
    }
  } catch (error) {
    console.log('Error create List');
  }
};

const analyzeVideos = async (body) => {
  const response = await apiService.post('/youtube/analisis/', body);
  try {
    if (response.status === 200 && response.data.success === 1) {
      return response.data;
    }
  } catch (error) {
    console.log('Error create List');
  }
};

const postSemanticClassification = async (params) => {
  const {
    listaId, analisisId, videoId, text,
  } = params;
  const body = {
    listaId,
    analisisId,
    beginOffset: text.beginOffset,
    clasificacion: text.clasificacion,
    videoId,
  };
  const response = await apiService.post(
    '/youtube/clasificacion_semantica/',
    body,
  );
  try {
    if (response.status === 200 && response.data.success === 1) {
      return response.data;
    }
  } catch (error) {
    console.log('Error post postSemanticClassification');
  }
};

const deleteVideo = async (id, videoId) => {
  const response = await apiService.delete(
    `/youtube/videos/?_id=${id}&videoId=${videoId} `,
  );
  try {
    if (response.status === 200 && response.data.success === 1) {
      return response.data;
    }
  } catch (error) {
    console.log('Error delete Video List');
  }
};

const confirmContext = async (params) => {
  const {
    listaId, analisisId, videoId, text,
  } = params;
  const body = {
    listaId,
    analisisId,
    beginOffset: text.beginOffset,
    contexto: text.contexto,
    videoId,
  };
  const response = await apiService.post('/youtube/contexto_frase/', body);
  try {
    if (response.status === 200 && response.data.success === 1) {
      return response.data;
    }
  } catch (error) {
    console.log('Error post contexto_frase');
  }
};

const deleteAnalysis = async (id, idAnalysis) => {
  const response = await apiService.delete(
    `/youtube/analisis/?_id=${id}&analisisId=${idAnalysis}`,
  );
  try {
    if (response.status === 200 && response.data.success === 1) {
      return response.data;
    }
  } catch (error) {
    console.log('Error delete Video List');
    return error;
  }
};

const cloudWords = async (idList, idAnalized, pageWords) => {
  const response = await apiService.get(
    `/youtube/nube_palabras/?listaId=${idList}&analisisId=${idAnalized}&limite=${pageWords}`,
  );
  try {
    if (response.status === 200) {
      return response.data.data;
    }
  } catch (error) {
    console.log('Error get List ');
  }
};

const cloudWordsById = async (idList, idAnalized, videoId, pageWords) => {
  const response = await apiService.get(
    `/youtube/nube_palabras/?listaId=${idList}&analisisId=${idAnalized}&videoId=${videoId}&limite=${pageWords}`,
  );
  try {
    if (response.status === 200) {
      return response.data.data;
    }
  } catch (error) {
    console.log('Error get List ');
  }
};

const getStatisticsPerVideo = async (videoId) => {
  const response = await apiService.get(`/youtube/estadisticas/video/?id=${videoId}`);
  try {
    if (response.status === 200) {
      return response.data.data;
    }
  } catch (error) {
    console.log('Error get getStatisticsPerVideo ');
  }
};

const gp3 = async (body) => {
  const response = await apiService.post('/youtube/gpt3/resumen/', body);
  try {
    if (response.status === 200) {
      return response.data.data;
    }
    return false;
  } catch (error) {
    console.log('Error get getStatisticsPerVideo ');
  }
};

const heaters = async (body) => {
  const response = await apiService.post('/youtube/haters/', body);
  try {
    if (response.status === 200) {
      return response.data.haters;
    }
    return false;
  } catch (error) {
    console.log('Error get heaters ');
  }
};

export {
  gp3,
  heaters,
  searchVideos,
  getListTags,
  createList,
  updateList,
  getFeelings,
  getComments,
  analyzeVideos,
  getVideosId,
  deleteList,
  evaluateFeeling,
  deleteVideo,
  cloudWords,
  getFeelingsById,
  confirmContext,
  cloudWordsById,
  deleteAnalysis,
  createVideoToList,
  getStatisticsPerVideo,
  getCommentsbyVideoId,
  postSemanticClassification,
};
